module.exports = __webpack_public_path__ + "img/logo_onebox-only-white.ef8abb5f.png";